import type { AxiosInstance, AxiosStatic } from 'axios';
import axiosRetry from 'axios-retry';

const BASE_DELAY = 1000;
const RETRIES = 3;

export function addAxiosRetry(axios: AxiosStatic | AxiosInstance): void {
  axiosRetry(axios, {
    retries: RETRIES,
    retryDelay: (...args) => axiosRetry.exponentialDelay(...args, BASE_DELAY),
    retryCondition(error) {
      switch (error.response?.status) {
        case 500:
        case 501:
        case 502:
        case 503:
        case 504:
          return true;
        default:
          return false;
      }
    },
  });
}
